import React from 'react';
import classNames from 'classnames';
import s from './AiAnalyzingBorder.scss';
const ORBIT_DURATION_S = 2;
const ORBIT_CARD_LEAD_FRACTION_OF_LOOP = 0.08;
const getOrbitDelay = (cardIndex, cardCount) => -Math.max(0, cardCount - 1 - cardIndex) * ORBIT_DURATION_S * ORBIT_CARD_LEAD_FRACTION_OF_LOOP;
export const AiAnalyzingBorder = _ref => {
  let {
    mode,
    cardIndex,
    cardCount = 1
  } = _ref;
  const rootRef = React.useRef(null);
  React.useLayoutEffect(() => {
    const el = rootRef.current;
    if (!el) {
      return;
    }
    el.style.setProperty('--orbit-duration', `${ORBIT_DURATION_S}s`);
    el.style.setProperty('--orbit-delay', `${getOrbitDelay(cardIndex, cardCount)}s`);
  }, [cardIndex, cardCount]);
  return /*#__PURE__*/React.createElement("div", {
    ref: rootRef,
    className: classNames(s.root, s.orbit, {
      [s.modeTravel]: mode === 'travel',
      [s.modeGrow]: mode === 'grow',
      [s.modeFade]: mode === 'fade'
    }),
    "data-hook": "ai-analyzing-border",
    "aria-hidden": true
  }, /*#__PURE__*/React.createElement("div", {
    className: s.orbitRing
  }), /*#__PURE__*/React.createElement("div", {
    className: s.orbitFill,
    "data-hook": "ai-analyzing-orbit-fill"
  }));
};
//# sourceMappingURL=AiAnalyzingBorder.js.map